import { Component, Input } from "@angular/core";
import { BaseChartDirective } from "ng2-charts";
import { getSnapshotSummaryFromDaysAgo, SnapshotDailySummary } from "./user-collection-general-stats.component";
import { formatDate } from "@ponder-shared/utils/general";
import { environment } from "../../../../../environments/environment";
import { ChartBaseComponent } from "@ponder-shared/charts/chart-base.component";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";
import { NgClass } from "@angular/common";
import { FormatNumberPipe } from "@ponder-shared/pipes/format-number.pipe";

@Component({
    selector: "collection-snapshot-items-chart",
    imports: [NgClass, BaseChartDirective, FormatNumberPipe],
    templateUrl: "./collection-snapshot-items-chart.component.html"
})
export class CollectionSnapshotItemsChartComponent extends ChartBaseComponent {
    @Input({ required: true }) public snapshotSummaries!: SnapshotDailySummary[];

    public changeItems1w: number = 0;
    public changeItems1m: number = 0;
    public changeItems1y: number = 0;
    public changeItemsAll: number = 0;

    public override ngOnInit(): void {
        this.dataLabel = "Items";
        this.xGridLineVisible = false;
        this.yGridLineVisible = false;
        this.yGridBorderVisible = false;
        this.xLabelColor = "#888";
        this.yLabelColor = "#888";
        this.lineWidth = 2;
        this.lineRadius = 2;
        this.lineColor = environment.colors.chart.blue;
        this.fillArea = true;
        this.backgroundColor = environment.colors.chart.bluefade;

        super.ngOnInit();

        this.setDataGlances();
        this.updateData();
    }

    private updateData(): void {
        var labels: string[] = [];

        var min = Number.MAX_SAFE_INTEGER;
        var max = 0;
        
        var past = (this.snapshotSummaries.length < 3) ? 3 - this.snapshotSummaries.length : 0;
        
        if (past) {
            for (let i = past; i > 0; i--) {
                var date = new Date();
                date.setDate(this.snapshotSummaries[0].date.getDate() - (7 * i));

                labels.push(formatDate(date));
                this.addDataPoint(null);
            }
        }

        this.snapshotSummaries.forEach(s => {
            min = Math.min(min, s.items);
            max = Math.max(max, s.items);

            labels.push(formatDate(s.date));
            this.addDataPoint(s.items);
        });

        this.minYValue = Math.floor(min * 0.95);
        this.maxYValue = Math.ceil(max * 1.05);

        this.setSuggestedYScale();
        this.setLabels(labels);
    }

    public isMobileScreen(): boolean {
        return isMobileScreen();
    }

    private setDataGlances(): void {
        if (!this.snapshotSummaries.length) {
            return;
        }

        var now = (new Date()).getTime();

        var snapshotFirst = this.snapshotSummaries[0];
        var snapshot1y = getSnapshotSummaryFromDaysAgo(365, now, this.snapshotSummaries);
        var snapshot1m = getSnapshotSummaryFromDaysAgo(28, now, this.snapshotSummaries);
        var snapshot1w = this.snapshotSummaries[Math.max(0, this.snapshotSummaries.length - 2)];
        var snapshotNow = this.snapshotSummaries[this.snapshotSummaries.length - 1];

        this.changeItemsAll = snapshotNow.items - snapshotFirst.items;
        this.changeItems1y = snapshotNow.items - snapshot1y.items;
        this.changeItems1m = snapshotNow.items - snapshot1m.items;
        this.changeItems1w = snapshotNow.items - snapshot1w.items;
    }
}